<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <b-card>
        <b-card-title>
          <div class="row">
            <h5 class="card-title col-md-6">Consultar</h5>
          </div>
        </b-card-title>

        <div class="row">
          <b-form-group
            label="Locadora"
            invalid-feedback="campo obrigatório"
            class="col-md-4 mb-3"
          >
            <multiselect 
              v-model="selectEmpresa" 
              placeholder="Selecione"
              :show-labels="false"
              :options="optionEmpresa"
              :allow-empty="false"
              :custom-label="({ nm_fantasia, nr_cgc_cpf }) => `${nm_fantasia} [${$tools.converterCnpj(nr_cgc_cpf)}]`"
            />
          </b-form-group>
          <b-form-group class="mt-4 col-md-2">
            <b-button variant="primary" @click="filtrar()" class="m-1">
                <i class="mdi mdi-filter-outline font-size-15 align-middle me-2"></i>
                Filtrar
              </b-button>
          </b-form-group>
        </div>
      </b-card>

      <div class="card" v-if="viewSolicitacao">
        <div class="card-body">
          <div id="tickets-table_filter" class="dataTables_filter">
            <label class="d-inline-flex align-items-center">
              <b-form-input
                v-model="filtro"
                type="search"
                placeholder="Pesquisar..."
                class="form-control form-control-sm ms-2"
              ></b-form-input>
            </label>
          </div>

          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              responsive="sm"
              :items="solicitacao"
              :fields="campos"
              :filter="filtro"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(actions)="data">
                <div class="button-items">
                  <b-button
                    variant="success"
                    @click.prevent="
                      forVincularSolicitacaoInVeiculo(data.item.sq_solvei)
                    "
                  >
                    <i class="bx bx-car"></i>
                  </b-button>
                </div>
              </template>
            </b-table>

            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Multiselect from 'vue-multiselect';

export default {
  page: {
    title: "Tabela solicitação",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    Multiselect
  },
  data() {
    return {
      title: "Solicitações",
      items: [
        {
          text: "Locadora",
          active: false,
        },
        {
          text: "Solicitações",
          href: "/locadora/solicitacao",
        },
      ],
      alerta: false,
      filtro: "",
      variante: "",
      mensagem: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      filterOn: [],
      solicitacao: [],
      campos: [
        {
          key: "nm_razao_coop",
          label: "Cooperado",
          sortable: true,
        },
        {
          key: "nm_projeto",
          label: "Projeto",
          sortable: true,
        },
        {
          key: "nm_regiao_entrega",
          label: "Cidade Sede",
          sortable: true,
        },
        {
          key: "actions",
          label: "Ações",
        },
      ],
      optionEmpresa:[],
      selectEmpresa:"",
      viewSolicitacao:false
    };
  },

  created() {
    this.$http.get("api/auth/buscarEmpresas").then((response) => {
      this.optionEmpresa = response.data;
      this.selectEmpresa = this.optionEmpresa[0];
      if(this.optionEmpresa.length == 1){
        this.filtrar();
      }
    });

  },

  computed: {
    rows() {
      return this.solicitacao.length;
    },
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    filtrar() {
      this.$http.get("api/veiculo/buscarSolicitacao/"+this.selectEmpresa.cd_pessoa).then((response) => {
        this.solicitacao = response.data;
        this.viewSolicitacao = true;
      });
    },

    forVincularSolicitacaoInVeiculo(sqSolVei) {
      this.$router.push(`/locadora/solicitacao/${sqSolVei}`);
    },
    
  },
};
</script>
